namespace RioERP.Users {
    export interface TeachersForm {
        Name: Serenity.StringEditor;
        Description: Serenity.TextAreaEditor;
        Email: Serenity.EmailEditor;
        AlternateEmail: Serenity.EmailEditor;
        Mobile: Serenity.StringEditor;
        AlternateMobile: Serenity.StringEditor;
        Address: Serenity.StringEditor;
        City: Serenity.StringEditor;
        StateId: Serenity.LookupEditor;
        Gstin: Serenity.StringEditor;
        Pan: Serenity.StringEditor;
        GstCertificate: Serenity.MultipleImageUploadEditor;
        IsGstApplicable: Serenity.BooleanEditor;
        BankName: Serenity.StringEditor;
        BankAccountType: Serenity.EnumEditor;
        BankAccountName: Serenity.StringEditor;
        BankAccountNo: Serenity.StringEditor;
        BankIfscCode: Serenity.StringEditor;
        Pincode: Serenity.IntegerEditor;
    }

    export class TeachersForm extends Serenity.PrefixedContext {
        static formKey = 'Users.Teachers';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TeachersForm.init)  {
                TeachersForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.EmailEditor;
                var w3 = s.LookupEditor;
                var w4 = s.MultipleImageUploadEditor;
                var w5 = s.BooleanEditor;
                var w6 = s.EnumEditor;
                var w7 = s.IntegerEditor;

                Q.initFormType(TeachersForm, [
                    'Name', w0,
                    'Description', w1,
                    'Email', w2,
                    'AlternateEmail', w2,
                    'Mobile', w0,
                    'AlternateMobile', w0,
                    'Address', w0,
                    'City', w0,
                    'StateId', w3,
                    'Gstin', w0,
                    'Pan', w0,
                    'GstCertificate', w4,
                    'IsGstApplicable', w5,
                    'BankName', w0,
                    'BankAccountType', w6,
                    'BankAccountName', w0,
                    'BankAccountNo', w0,
                    'BankIfscCode', w0,
                    'Pincode', w7
                ]);
            }
        }
    }
}
